import type { ApprovalStatus, Vendor } from '@shopgnd/shared';

/** Vendors visible in the admin approval queue (not yet live on the marketplace). */
export function vendorAwaitingAdminReview(status?: ApprovalStatus): boolean {
  const s = status ?? 'none';
  return s === 'pending' || s === 'none';
}

export function vendorIsApproved(status?: ApprovalStatus): boolean {
  return (status ?? 'none') === 'approved';
}

export function vendorIsRejected(status?: ApprovalStatus): boolean {
  return status === 'rejected';
}

/** Router state for shop redirect when a seller hub route is blocked (pending review). */
export type SellerHubShopNoticeState = {
  sellerPending: boolean;
  sellerRejected: boolean;
  message: string;
};

export function sellerHubShopNoticeState(
  vendor: Pick<Vendor, 'approvalStatus' | 'approvalNote'> | null | undefined,
): SellerHubShopNoticeState {
  if (!vendor) {
    return {
      sellerPending: true,
      sellerRejected: false,
      message:
        'Your seller application is pending approval. You can browse and buy on ShopGND until your store is approved.',
    };
  }
  if (vendorIsRejected(vendor.approvalStatus)) {
    const note = vendor.approvalNote?.trim();
    return {
      sellerPending: true,
      sellerRejected: true,
      message: note
        ? `Your store application was not approved: ${note}. Contact support if you have questions.`
        : 'Your store application was not approved. Contact support if you have questions.',
    };
  }
  return {
    sellerPending: true,
    sellerRejected: false,
    message:
      'Your seller application is pending approval. You can browse and buy on ShopGND until your store is approved.',
  };
}
